export default __webpack_public_path__ + "static/media/calendar-check-regular.62bca975.svg";